import { memo } from "react";

import { Button, ContentCard } from "@narmi/design_system";
import { Localized, useLocalization } from "@fluent/react";

import { useIncomeReportingCard } from "../hooks";

import styles from "./IncomeReportingProfileCard.module.scss";
import { IncomeReportingContainer } from "./IncomeReportingContainer";

const IncomeReportingEmpty = () => {
  const { l10n } = useLocalization();
  const { openFormHandler, isFormOpen, dismissFormHandler } =
    useIncomeReportingCard();

  return (
    <ContentCard kind="elevated">
      <div className={styles.container}>
        <Localized id="income-reporting-card-title">
          <span className={styles.title}>Income reporting</span>
        </Localized>
        <Localized id="income-reporting-card-body">
          <span className={styles["body-text"]}>
            We need your income information to tailor your banking experience.
          </span>
        </Localized>
        <div>
          <Button
            label={l10n.getString(
              "income-reporting-card-add-button",
              null,
              "Add information"
            )}
            onClick={openFormHandler}
          />
        </div>
      </div>
      <IncomeReportingContainer
        DialogFormProps={{
          isOpen: isFormOpen,
          onUserDismiss: dismissFormHandler,
        }}
      />
    </ContentCard>
  );
};

export default memo(IncomeReportingEmpty);
